import { render, staticRenderFns } from "./hisTest.vue?vue&type=template&id=15943840&scoped=true&"
import script from "./hisTest.vue?vue&type=script&lang=js&"
export * from "./hisTest.vue?vue&type=script&lang=js&"
import style0 from "./hisTest.vue?vue&type=style&index=0&id=15943840&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15943840",
  null
  
)

export default component.exports